import VideoJSPlayer from './VideoJSPlayer';

export default VideoJSPlayer;
